module.exports = __webpack_public_path__ + "static/img/get-to-the-management-team_7.ff65ab1.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/about-us/get-to-the-management-team_7.png
// module id = hg/z
// module chunks = 0